import { Description, Label, RadioGroup } from '@headlessui/react';
import PropTypes from 'prop-types';
import FormError from '@components/forms/common/FormError.component.jsx';

function RadioGroupWrapper({
  ref,
  label,
  subLabel,
  value = '',
  onChange,
  children,
  error,
}) {
  return (
    <>
      <RadioGroup ref={ref} value={value} onChange={onChange}>
        <Label className="text-base font-semibold text-event-light">
          {label}
        </Label>
        <Description
          as="p"
          className="text-base font-semibold text-event-muted"
        >
          {subLabel}
        </Description>
        {error && <FormError className={'my-2'} error={error} />}
        <div className="space-y-2 my-1 px-2">{children}</div>
      </RadioGroup>
    </>
  );
}

RadioGroupWrapper.propTypes = {
  label: PropTypes.string.isRequired,
  subLabel: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.object,
  children: PropTypes.node.isRequired,
};
export default RadioGroupWrapper;
